module.exports = __webpack_public_path__ + "static/media/ic-arrow-left-green.afbde448.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-arrow-left-green.svg
// module id = 591
// module chunks = 14